/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from "react";
import { useSelector } from "react-redux";
import CMSDESITableComponent from "./CMSDESITableComponent";

const CMSDESI = (props) => {
  const currentNDCDetailsSelected = useSelector(
    (state) => state.sharedState.ndc.currentNDCDetailsSelected
  );

  return (
    <div className="row">
      <CMSDESITableComponent
        currentNDCDetailsSelected={currentNDCDetailsSelected}
        {...props}
      />
    </div>
  );
};

export default CMSDESI;
